<template lang="pug">
.room-3d-iframe
	template(v-if="data && data.content && data.content.src")
		iframe.video(:width="data.content.width" :height="data.content.height" :id="data.content.id" :src="data.content.src" :title="data.content.title" :frameborder="data.content.frameborder" :allow="data.content.allow" :allowfullscreen="data.content.allowfullscreen")
	.room-3d-slot(v-else-if="data && data.html" v-html="data.html")
	template(v-else)
		v-loader(loading)
</template>

<script>
import sourceMixin from "components/mixins/v-mixin-source.vue"

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data
		}
	}
}
</script>